"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERRAL_API_URLS = void 0;
var REFERRAL_API_URLS;
(function (REFERRAL_API_URLS) {
    REFERRAL_API_URLS["CREATE_REFERRAL_INFO"] = "/v2/referral/create";
    REFERRAL_API_URLS["GET_REFERRAL_ALL"] = "/v2/referral/get-all";
    REFERRAL_API_URLS["CHANGE_REFERRAL_STATUS"] = "/v2/referral/change_status";
    REFERRAL_API_URLS["REGISTER_REFERRAL"] = "/v2/user/register-referral";
    REFERRAL_API_URLS["GET_INFLUENCER_REFERRALS"] = "/v2/referral/get-my";
    REFERRAL_API_URLS["GET_TRANSACTIONS"] = "/v2/referral/get-transactions";
    REFERRAL_API_URLS["CREATE_ORDER"] = "/v2/referral/order/create";
    REFERRAL_API_URLS["UPDATE_ORDER"] = "/v2/referral/order/update";
    REFERRAL_API_URLS["DOWNLOAD_CSV"] = "/v2/referral/get-csv";
    REFERRAL_API_URLS["FETCH_USERS"] = "/v2/referral/get-users";
})(REFERRAL_API_URLS = exports.REFERRAL_API_URLS || (exports.REFERRAL_API_URLS = {}));
